import { Component } from 'react';
import { connect } from 'react-redux';
import { actionCleanMessage } from 'redux/actions/SharedActions';
import { toast, Zoom } from 'react-toastify';
import 'assets/css/ToastMessage.css';
import { GetTranslation } from 'redux/actions/TranslatorActions';

class Message extends Component {

  componentDidUpdate = (prevProps) => {
    if (this.props.oShared.sMessage !== '' && this.props.oShared.sMessage !== 'Unauthorized') {
      const { sLanguage } = this.props.oTranslator;
      toast(GetTranslation(sLanguage, this.props.oShared.sMessage), {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        type: this.props.oShared.sMessageType,
        transition: Zoom
      });
      this.props.cleanMessage();
    }
  }

  render = () => {
    return null
  }
}

const mapStateToProps = oState => ({
  oShared: oState.SharedReducer,
  oTranslator: oState.TranslatorReducer,
})

const mapDispatchToProps = dispatch => ({
  cleanMessage: () => {
    dispatch(actionCleanMessage());
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(Message);